import React from 'react';
import ReactDOM from 'react-dom/client';
import { LandingScopeGroupProps } from './ILandingScopeGroup';
import { LandingScopeGroupPage } from './LandingScopeGroup';
import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: LandingScopeGroupProps;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const data = (window as unknown as WindowWithData).data || {};

root.render(
  <LandingScopeGroupPage
    productgroupsDropdownList={data.productgroupsDropdownList}
    productGroups={data.productGroups}
    isParticulier={data.isParticulier}
  />
);
